import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import Reveal from '../components/Reveal';
import InquiryForm from '../components/InquiryForm';

const infos = [
  { icon: Phone, label: 'Call us', value: '+91 9444 150808' },
  { icon: Mail, label: 'Email', value: 'hello@eventstory4u.com' },
  { icon: MapPin, label: 'Office', value: 'Mumbai, India' },
  { icon: Clock, label: 'Hours', value: 'Mon–Sun · 9am–9pm' },
];

export default function Contact() {
  return (
    <div className="section py-12">
      <Reveal className="mb-10 text-center">
        <h1 className="font-display text-4xl font-extrabold">Let's <span className="text-gradient">Talk</span></h1>
        <p className="mt-3 text-ink-300">Share your event details and we'll reach out on WhatsApp instantly.</p>
      </Reveal>

      <div className="grid gap-8 lg:grid-cols-[1fr_1.3fr]">
        <Reveal className="space-y-4">
          {infos.map((i) => (
            <div key={i.label} className="glass flex items-center gap-4 p-5">
              <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-gradient text-white">
                <i.icon size={20} />
              </span>
              <div>
                <p className="text-xs text-ink-400">{i.label}</p>
                <p className="font-medium text-white">{i.value}</p>
              </div>
            </div>
          ))}
        </Reveal>

        <Reveal delay={0.1} className="glass p-6 sm:p-8">
          <h2 className="mb-5 font-display text-xl font-bold">Send an Inquiry</h2>
          <InquiryForm origin="contact" />
        </Reveal>
      </div>
    </div>
  );
}
